import React from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {HelpResourceItemContent} from './helpResourceItem';

export const communityHelpResourceItem: HelpResourceItemContent = {
  icon: 'groupSmall',
  title: <Trans id="help-resource-item-community-title">Community</Trans>,
  description: (
    <Trans id="help-resource-item-community-description">
      Ask questions, get inspired, and connect with peers to share learnings.
    </Trans>
  ),
};

export const helpCenterHelpResourceItem: HelpResourceItemContent = {
  icon: 'knowledgeBaseFilledSmall',
  title: <Trans id="help-resource-item-help-center-title">Help Center</Trans>,
  description: (
    <Trans id="help-resource-item-help-center-description">
      Find answers and explore features in these comprehensive guides.
    </Trans>
  ),
};

export const liveTrainingHelpResourceItem: HelpResourceItemContent = {
  icon: 'webinarLibrary',
  title: <Trans id="help-resource-item-training-title">Live training</Trans>,
  description: (
    <Trans id="help-resource-item-training-description">
      Join a session to take a tour of Front and get questions answered.
    </Trans>
  ),
};

const contactSupportTitle = <Trans id="help-resource-item-support-title">Contact support</Trans>;

export const chatWithSupportHelpResourceItem: HelpResourceItemContent = {
  icon: 'channelChatSmall',
  title: contactSupportTitle,
  description: (
    <Trans id="help-resource-item-chat-support-description">
      For help troubleshooting, chat with our support team.
    </Trans>
  ),
  isInternal: true,
};

export const messageSupportHelpResourceItem: HelpResourceItemContent = {
  icon: 'channelEmailSmall',
  title: contactSupportTitle,
  description: (
    <Trans id="help-resource-item-message-support-description">
      For help troubleshooting, send our support team an email in Front.
    </Trans>
  ),
  isInternal: true,
};

export const emailSupportHelpResourceItem: HelpResourceItemContent = {
  icon: 'channelEmailSmall',
  title: contactSupportTitle,
  description: (
    <Trans id="help-resource-item-email-support-description">
      For help troubleshooting, send an email to our support team.
    </Trans>
  ),
};
